<div id="info">
	<div class="d-flex align-items-center justify-content-center flex-wrap pt-5">
		@for(dataItem of data; track dataItem; let index = $index) {
		<div class="w-100 d-flex align-items-center justify-content-center" [style.background-color]="$odd ? 'var(--theme-palette-100)' : ''">
			<div class="d-flex align-items-center justify-content-center py-4" [class]="mobileView ? 'w-100' : 'w-75'">
				@if (dataItem.type === 'text' || dataItem.type === 'highlight') {
				<div
					class="text-block-container d-flex flex-wrap align-items-center justify-content-center w-100"
					[ngClass]="{ 'flex-row-reverse': $even, 'flex-row': $odd, highlight: dataItem.type === 'highlight' }">
					@for(content of dataItem.content; track content; let contentIndex = $index) {
					<div class="d-flex flex-wrap p-3 pe-4 w-100 justify-content-center" [ngClass]="{ 'w-50': dataItem.content.length > 1 || content.image, 'w-100': mobileView }">
						@if(dataItem.leading) {
						<div class="d-flex w-100">
							<div class="blob me-2" [class]="$even ? 'style-1' : 'style-2'"></div>
							<span class="small-heading"> {{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.leading | translate }}</span>
						</div>
						}

						<div class="w-100 mt-2 mb-5">
							@if(content.title) {
							<span class="heading mb-2">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.title | translate }}</span>
							}
						</div>

						<p class="m-0 p-0">
							@if (content.leading) {
							<strong>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.leading | translate }}</strong>
							} @if(content.text) {
							{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.text | translate }}
							}
						</p>
						<!-- <div class="break"></div> -->
						<!-- <div class="break"></div> -->

						<!-- @if (dataItem.readMore) {
              <div class="d-flex w-100 justify-content-center">
                <button class="mt-3" mat-stroked-button color="primary" (click)="navigateToPage(dataItem.routerLink)">{{ 'BUTTON.READ_MORE' | translate }}</button>
              </div>
              } -->
					</div>

					@if(content.image) {
					<img class="img-fluid style-1 w-50" [src]="content.image" alt="home block image" />
					} }
				</div>
				} @else if (dataItem.type === "button") { @for(content of dataItem.content; track content; let contentIndex = $index) {
				<div class="d-flex w-100 justify-content-center">
					<button class="mt-3" mat-stroked-button color="primary" (click)="utils.navigateToPage(content.routerLink)">
						{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.title | translate }}
					</button>
				</div>
				} } @else {
				<div class="d-flex flex-wrap px-3" [class]="mobileView ? 'w-100' : 'w-50'">
					@if(dataItem.title){
					<div class="w-100 mt-2 mb-5">
						<span class="heading mb-3">{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + dataItem.title | translate }}</span>
					</div>
					} @for(content of dataItem.content; track content; let contentIndex = $index) { @if (content.leading) {
					<div class="w-100">
						<span>
							<strong>{{ 'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.leading | translate }}</strong>
						</span>
					</div>
					}
					<p class="w-100 pb-2"  [innerHTML]="'LANDING.' + (resellerSettingsContext.reseller.name | uppercase) + '.' + content.text | translate">

					</p>
					<div class="break"></div>
					}
				</div>
				}
			</div>
		</div>

		<div class="break"></div>
		}
	</div>
</div>
